"use client"

import styled from "@emotion/styled"
import { IconButton } from "@mui/material"
import { useQuery } from "@tanstack/react-query"
import { TableDto } from "api"
import { generatePDF } from "lib/generatePDF"
import { getPricesList } from "lib/utils"
import { useState } from "react"
import colors from "theme/colors"
import {
  Accordion,
  ArchiveIcon,
  NewText,
  PrintIcon,
  TitleWithLine,
  useIsDesktop,
} from "ui"
import { extractProperty } from "utils"
import TableData from "./TableData"

const StyledPriceContainer = styled.div`
  padding-top: 40px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 60px;
    padding-left: 146px;
    padding-right: 146px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding-top: 80px;
    padding-left: 220px;
    padding-right: 220px;
  }
`

const StyledTitleWrapper = styled.div`
  ${(props) => props.theme.breakpoints.down("sm")} {
    padding-left: 28px;
    padding-right: 28px;
  }
  display: flex;
  justify-content: space-between;
  svg {
    margin-right: 4px;
  }
  margin-bottom: 20px;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-bottom: 28px;
  }
  ${(props) => props.theme.breakpoints.down("lg")} {
    margin-bottom: 40px;
  }
`

const StyledTableWrapper = styled.div`
  border-bottom: 1.5px solid ${colors.black};
  padding-top: 24px;
  padding-bottom: 32px;
  ${(props) => props.theme.breakpoints.down("sm")} {
    padding-left: 28px;
  }
`

const StyledIconButton = styled(IconButton)`

:focus-visible{
  border:1px solid gray;
}`

const StyledButtonWrapper = styled.div``

interface props {
  data: any
  priceList: TableDto
  diplomatsList: TableDto
  servicesList: TableDto
  listData: {
    prices: TableDto
    diplomats: TableDto
    services: TableDto
  }
}
function PazomatPrice({
  data,
  listData,
}: props) {
  const [archive, setArchive] = useState(false)
  const { data: lists } = useQuery<{
    prices: TableDto
    diplomats: TableDto
    services: TableDto
  }>({
    queryKey: ["archive", archive],
    queryFn: async () => await getPricesList(archive),
    refetchOnWindowFocus: false,
    initialData: listData,
  })
  const handleArchive = () => {
    setArchive((el) => !el)
  }
  const isDesktop = useIsDesktop()


  const priceList = lists?.prices
  const diplomatsList = lists?.diplomats
  const servicesList = lists?.services

  const title = extractProperty(data, "sideMenuTitle")
  return (
    <StyledPriceContainer>
      <StyledTitleWrapper>
        <TitleWithLine
          title={title}
          titleFontSize={isDesktop ? 64 : 32}
          titleColor={colors.black}
        />
        <StyledButtonWrapper>
          <StyledIconButton
            disableRipple
            onClick={() =>
              generatePDF([
                priceList,
                {
                  ...diplomatsList,
                  Header: { Columns: ["סוג דלק", "מחיר", "כמות"] },
                },
                servicesList,
              ])
            }
          >
            <PrintIcon />
            <NewText
              desktopFontSize={14}
              component="p"
              desktopLineHeight="150%"
              desktopFontWeight="400"
              color={colors.blue}
            >
              הדפסה
            </NewText>
          </StyledIconButton>
          <StyledIconButton onClick={handleArchive} disableRipple>
            <ArchiveIcon />
            <NewText
              desktopFontSize={14}
              component="p"
              desktopLineHeight="150%"
              desktopFontWeight="400"
              color={colors.blue}
            >
              ארכיון
            </NewText>
          </StyledIconButton>
        </StyledButtonWrapper>
      </StyledTitleWrapper>
      {priceList &&
        <Accordion title={priceList.Title} index={0}>
          <StyledTableWrapper>

            <TableData
              header={priceList.Header}
              rows={priceList.Rows}
              index={0}
              title={priceList.Title}
            />
          </StyledTableWrapper>
        </Accordion>
      }
      {diplomatsList &&
        <Accordion title={diplomatsList.Title} index={1}>
          <StyledTableWrapper>
            <TableData
              header={{ Columns: ["סוג דלק", "מחיר", "כמות", "תקף מ", "תקף עד"].slice(0, diplomatsList.Rows.length) }}
              rows={diplomatsList.Rows}
              index={1}
              title={diplomatsList.Title}
            />
          </StyledTableWrapper>
        </Accordion>
      }
      {servicesList &&
        <Accordion title={servicesList.Title} index={2}>
          <StyledTableWrapper>
            <TableData
              header={servicesList.Header}
              rows={servicesList.Rows}
              index={2}
              title={servicesList.Title}
            />
          </StyledTableWrapper>
        </Accordion>
      }
    </StyledPriceContainer>
  )
}
export default PazomatPrice
